import React from 'react';
import MediaComponent from '../../activity/MediaComponent';

export default function Mcqs({ answer, isSubmitted }) {
  return (
    <div className="mcqs-parent mr-tp-bt answer_box">
      {answer?.question?.options?.map((option, i) => (
        <div
          className=""
          style={{ minWidth: "50%", paddingRight: ".525rem" }}
          key={i}
        >
          <p
            className="p-2 mt-2 mb-0 w-100 d-flex align-items-center gap-2"
            style={{
              borderRadius: '2px',
              ...(answer?.answerIndex === i
                ? {
                    borderBottom: "3px solid var(--Purple-700, #6700B2)",
                    borderTop: "1px solid var(--Purple-700, #6700B2)",
                    borderRight: "3px solid var(--Purple-700, #6700B2)",
                    borderLeft: "1px solid var(--Purple-700, #6700B2)",
                  }
                : { border: "1px solid var(--Grey-300, #E6E5E4)" }),
            }}
          >
            <span
              className="d-flex align-items-center justify-content-center p-1 rounded-1 f-12 align-self-start"
              style={{
                ...(answer?.answerIndex === i
                  ? { border: "1px solid var(--Grey-600, #6700B2)" }
                  : { border: "1px solid var(--Grey-600, #9D9690)" }),
                width: "20px",
                height: "20px",
                fontWeight: "600",
              }}
            >
              {String.fromCharCode(65 + i)}
            </span>
            {option?.type !== 'text' ? (
              <MediaComponent
                media={option}
                mode={'student'}
                setMaximizeImage={() => {}}
                setImageVideoUrl={() => {}}
              />
            ) : (
              option.text
            )}
          </p>
        </div>
      ))}
    </div>
  );
}
